import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactPage from './pages/ContactPage';
import LiveGoldRatePage from './pages/LiveGoldRatePage';
import TransparencyPage from './pages/TransparencyPage';
import GoldJewelleryPage from './pages/GoldJewelleryPage';
import WeddingJewelleryPage from './pages/WeddingJewelleryPage';
import SilverJewelleryPage from './pages/SilverJewelleryPage';
import WomenJewelleryPage from './pages/WomenJewelleryPage';
import GoldRatePage from './pages/GoldRatePage';
import GoldRateRajasthanPage from './pages/GoldRateRajasthanPage';
import GoldGuidePage from './pages/GoldGuidePage';
import HowToCheckGoldPurityPage from './pages/HowToCheckGoldPurityPage';
import BestTimeToBuyGoldPage from './pages/BestTimeToBuyGoldPage';
import TrustedJewelleryStorePage from './pages/TrustedJewelleryStorePage';
import BisHallmarkingGuidePage from './pages/BisHallmarkingGuidePage';
import JewelleryCareGuidePage from './pages/JewelleryCareGuidePage';
import ReturnExchangePolicyPage from './pages/ReturnExchangePolicyPage';
import './styles/theme.css';
import './styles/global.css';
import './styles/common.css';
import './styles/components.css';
import AdminPage from './pages/AdminPage';
import './styles/Admin.css';
import './styles/MakeBillPage.css';
import './styles/ManageCustomersPage.css'
import './styles/Auth.css'; // Premium Auth Styles
import ForgotPasswordPage from './pages/AuthenticationPage/ForgotPasswordPage';
import ResetPasswordPage from './pages/AuthenticationPage/ResetPasswordPage';
import AddJewelleryPage from './pages/AddJewelleryPage';
import JewelleryListPage from './pages/JewelleryListPage';
import JewelleryDetailPage from './pages/JewelleryDetailPage';
import BillingPage from './pages/BillingPage';
import BillHistoryPage from './pages/BillHistoryPage';
import CustomerManagementPage from './pages/CustomerManagementPage';
import UserManagementPage from './pages/UserManagementPage';
import ProfilePage from './pages/ProfilePage';
import GoldInvestmentTrackerPage from './pages/GoldInvestmentTrackerPage';
import Footer from './components/Layout/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import VerifyHuidPage from './pages/VerifyHuidPage';
import { HelmetProvider } from 'react-helmet-async';

const AppContent = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMobileMenu = () => {
    console.log('Toggle mobile menu, current state:', mobileMenuOpen);
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  return (
    <Router>
      <div className="app-container">

        {/* Google Style Top App Bar */}
        <nav className="google-navbar">
          <div className="navbar-container">
            {/* Left: Brand */}
            <Link to="/" className="navbar-brand">
              <img src={require('./assets/logo_full.webp')} alt="MAB Jewels" className="brand-logo" />
              <h2>MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)</h2>
            </Link>

            {/* Center: Navigation */}
            <div className={`navbar-menu-container ${mobileMenuOpen ? 'mobile-active' : ''}`}>
              <ul className="navbar-menu">
                {isAuthenticated && (user?.role === 'admin' || user?.role === 'super-admin' || user?.role === 'co-admin') ? (
                  /* Admin Navigation */
                  <>
                    <li><NavLink to="/admin" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu} end>Dashboard</NavLink></li>
                    <li><NavLink to="/jewellery" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Jewellery</NavLink></li>
                    <li><NavLink to="/billing" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Billing</NavLink></li>
                    <li><NavLink to="/customers" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Customers</NavLink></li>
                    {user?.role === 'super-admin' && (
                      <li><NavLink to="/admin/users" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Users</NavLink></li>
                    )}
                  </>
                ) : (
                  /* Public / Authenticated End-User Navigation */
                  <>
                    <li><NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu} end>Home</NavLink></li>
                    <li><NavLink to="/jewellery" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Jewellery</NavLink></li>
                    <li><NavLink to="/live-gold-rate" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Gold Rate</NavLink></li>
                    <li><NavLink to="/verify-huid" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Verify HUID</NavLink></li>
                    <li><NavLink to="/gold-guide" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Gold Guide</NavLink></li>
                    <li><NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>About</NavLink></li>
                    <li><NavLink to="/contact" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>Contact</NavLink></li>
                  </>
                )}
              </ul>

              {/* Mobile Only Actions in Menu */}
              <div className="mobile-actions">
                {isAuthenticated ? (
                  <div className="mobile-user-actions">
                    <div className="user-greeting">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" /></svg>
                      <span>Hi, {user?.firstName}</span>
                    </div>
                    <Link to="/profile" className="btn-google btn-google-profile" onClick={closeMobileMenu}>My Profile</Link>
                    <button onClick={() => { logout(); closeMobileMenu(); }} className="btn-google btn-google-logout">Logout</button>
                  </div>
                ) : (
                  <>
                    <Link to="/login" className="btn-google btn-google-login" onClick={closeMobileMenu}>Login</Link>
                  </>
                )}
              </div>
            </div>

            {/* Right: Actions (Desktop) */}
            <div className="navbar-actions desktop-only">
              {isAuthenticated ? (
                <div className="desktop-user-actions">
                  <div className="user-dropdown-container">
                    <div className="user-greeting dropdown-trigger">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" /></svg>
                      <span>Hi, {user?.firstName}</span>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" className="dropdown-arrow"><path d="M7 10l5 5 5-5z" /></svg>
                    </div>
                    <div className="user-dropdown-menu">
                      <Link to="/profile" className="dropdown-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        My Profile
                      </Link>
                      <Link to="/gold-investment-tracker" className="dropdown-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
                        My Gold Portfolio
                      </Link>
                      <div className="dropdown-divider"></div>
                      <button onClick={logout} className="dropdown-item dropdown-item--danger">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Link to="/login" className="btn-google btn-google-login">Login</Link>
              )}
            </div>

            {/* Hamburger Button */}
            <div
              ref={hamburgerRef}
              className={`hamburger-menu ${mobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
            >
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </div>
          </div>
        </nav>

        {/* Mobile Menu Backdrop */}
        {mobileMenuOpen && (
          <div className="mobile-menu-backdrop" onClick={closeMobileMenu} />
        )}

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/live-gold-rate" element={<LiveGoldRatePage />} />
            <Route path="/transparency" element={<TransparencyPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

            {/* SEO Landing Pages */}
            <Route path="/gold-jewellery-jodhpur" element={<GoldJewelleryPage />} />
            <Route path="/silver-jewellery-jodhpur" element={<SilverJewelleryPage />} />
            <Route path="/women-jewellery-jodhpur" element={<WomenJewelleryPage />} />
            <Route path="/wedding-jewellery-rajasthan" element={<WeddingJewelleryPage />} />
            <Route path="/gold-rate-jodhpur" element={<GoldRatePage />} />
            <Route path="/gold-rate-rajasthan" element={<GoldRateRajasthanPage />} />
            <Route path="/how-to-check-gold-purity-rajasthan" element={<HowToCheckGoldPurityPage />} />
            <Route path="/best-time-to-buy-gold-rajasthan" element={<BestTimeToBuyGoldPage />} />
            <Route path="/trusted-jewellery-store-jodhpur" element={<TrustedJewelleryStorePage />} />
            <Route path="/trusted-jewellery-store-jodhpur" element={<TrustedJewelleryStorePage />} />
            <Route path="/bis-hallmarking-guide" element={<BisHallmarkingGuidePage />} />
            <Route path="/jewellery-care-guide" element={<JewelleryCareGuidePage />} />
            <Route path="/return-exchange-policy" element={<ReturnExchangePolicyPage />} />
            <Route path="/gold-guide" element={<GoldGuidePage />} />

            {/* Blog Routes - Professional Static Scheduling */}
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />

            {/* Tools */}
            <Route path="/verify-huid" element={<VerifyHuidPage />} />
            <Route path="/gold-investment-tracker" element={<GoldInvestmentTrackerPage />} />

            {/* Publicly Accessible Jewellery Page with Conditional Admin Rights */}
            <Route path="/jewellery" element={<JewelleryListPage isAdmin={isAuthenticated && ['admin', 'super-admin', 'co-admin'].includes(user?.role)} />} />
            <Route path="/jewellery/:slug" element={<JewelleryDetailPage />} />

            {/* General Protected Routes */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />

            {/* Protected Routes - ADMIN ONLY */}
            <Route path="/admin/*" element={
              <ProtectedRoute adminOnly={true}>
                <AdminPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute adminOnly={true}>
                <UserManagementPage />
              </ProtectedRoute>
            } />
            <Route path="/add-jewellery" element={
              <ProtectedRoute adminOnly={true}>
                <AddJewelleryPage />
              </ProtectedRoute>
            } />
            <Route path="/billing" element={
              <ProtectedRoute adminOnly={true}>
                <BillingPage />
              </ProtectedRoute>
            } />
            <Route path="/billing/history" element={
              <ProtectedRoute adminOnly={true}>
                <BillHistoryPage />
              </ProtectedRoute>
            } />
            <Route path="/customers" element={
              <ProtectedRoute adminOnly={true}>
                <CustomerManagementPage />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;
